import { Box, Typography, useTheme } from "@mui/material";
import { useMediaQuery } from "../../utilities/index.js";
import React from "react";
export const SuspectName = ({ age, name, sx = {} }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    return isDesktop ? (React.createElement(Box, { className: "suspect-name", sx: { mb: 1.5, ...sx } },
        React.createElement(Typography, { component: "div", variant: "h5", sx: {
                background: theme.palette.text.primary,
                borderRadius: "5px",
                color: "white",
                display: "inline-block",
                fontSize: "1.2rem !important",
                letterSpacing: "0.025em !important",
                lineHeight: "1 !important",
                pb: 0.6,
                pt: 0.4,
                px: 1.25,
                textTransform: "none",
            } },
            name,
            " (",
            age,
            process.env.NEXT_PUBLIC_LNG === "fr" ? " ans" : "",
            ")"))) : (React.createElement(Box, { className: "suspect-name", sx: { mb: 0.5, ...sx } },
        React.createElement(Typography, { component: "div", variant: "h5", sx: {
                background: theme.palette.text.primary,
                borderRadius: "4px",
                color: "white",
                display: "inline-block",
                fontSize: "1rem !important",
                letterSpacing: "0 !important",
                lineHeight: "1 !important",
                pb: 0.35,
                pt: 0.25,
                px: 1.25,
                textTransform: "none",
            } },
            name,
            " (",
            age,
            process.env.NEXT_PUBLIC_LNG === "fr" ? " ans" : "",
            ")")));
};
//# sourceMappingURL=suspect-name.js.map